import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createSessionActions } from './actions';
import { SessionActions, SessionState } from './types';

export const useSessionStore = create<SessionState & SessionActions>()(
    immer((set, get, store) => ({
        sessions: [],
        loading: false,
        selectedSession: null,
        loadingSession: false,
        error: undefined,
        ...createSessionActions(set, get, store),
    })),
);
